import alert from '@jetbrains/ring-ui/components/alert-service/alert-service'
import Button from '@jetbrains/ring-ui/components/button/button'
import * as React from 'react'
import {useMutation} from 'react-relay'

import type {AssignAgentsDialogBulkMoveItemsToAgentPoolMutation} from '../__generated__/AssignAgentsDialogBulkMoveItemsToAgentPoolMutation.graphql'
import {bulkMoveItemsToAgentPool} from '../AssignAgentsDialog.queries'

type Props = {
  agentPoolRawId: string
  authorizedAgentRawIds: Array<string>
  unauthorizedAgentRawIds: Array<string>
  agentTypeRawIds: Array<string>
  onAssign?: () => void
  className?: string | undefined
  disabled?: boolean
}

export default function AssignAgentsButton({
  className,
  disabled,
  agentTypeRawIds,
  authorizedAgentRawIds,
  unauthorizedAgentRawIds,
  agentPoolRawId,
  onAssign,
}: Props): React.ReactElement | null {
  const [commit, isInFlight] =
    useMutation<AssignAgentsDialogBulkMoveItemsToAgentPoolMutation>(bulkMoveItemsToAgentPool)

  const onClick = React.useCallback(() => {
    commit({
      variables: {
        agentTypeRawIds,
        authorizedAgentRawIds,
        unauthorizedAgentRawIds,
        agentPoolRawId,
      },
      onCompleted: (response, errors) => {
        if (errors == null) {
          onAssign?.()
        } else {
          errors.forEach(error => alert.error(error.message))
        }
      },
      onError: error => {
        alert.error(error.message)
      },
    })
  }, [
    commit,
    agentTypeRawIds,
    authorizedAgentRawIds,
    unauthorizedAgentRawIds,
    agentPoolRawId,
    onAssign,
  ])

  return (
    <Button primary loader={isInFlight} className={className} onClick={onClick} disabled={disabled}>
      {'Assign'}
    </Button>
  )
}
